import React from 'react';
import { Row, Col, Container, Form, FormGroup, Input } from 'reactstrap';

const Contact = () => {
    return (
        <div>
            
            <div className="contact1 spacer bg-light">
                    <Container>
                    <Row className="justify-content-center p-b-10">
                        <Col md="7" className="text-center">
                            <h1 className="title font-bold">Leave Feedback</h1>
                            <h6 className="subtitle">The best praise you can give us is by sharing your opinion!</h6>
                        </Col>
                    </Row>
                        <div className="p-t-20">
                            <Row className="m-0 justify-content-center">
                                <Col lg="8">
                                    <div className="contact-box p-r-40" >
                                        
                                        <Form action="https://formspree.io/xwknjvbw" method="POST">
                                            <Row>
                                                <Col lg="6">
                                                    <FormGroup className="m-t-15">
                                                        <Input type="text" name="name" placeholder="Name" required/>
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="6">
                                                    <FormGroup className="m-t-15">
                                                        <Input type="email" name="email" placeholder="Email" required/>
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="12">
                                                    <FormGroup className="m-t-15">
                                                        <Input type="textarea" name="message" placeholder="Feedback" required/>
                                                    </FormGroup>
                                                </Col>
                                                <Col lg="12">
                                                    <div className="row justify-content-center">
                                                    <button type="submit" className="btn  bg-success-gradiant m-t-20 btn-arrow"><span> Send Feedback <i className="ti-arrow-right"></i></span></button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
            </div>
        </div>
    );
}

export default Contact;
